import * as Sentry from "@sentry/react";

/**
 * Sentry init — browser-only. Ported from the Next.js `sentry.client.config.ts`
 * (server/edge configs are dropped along with SSR). AbortError filter retained
 * (see commit a8fc242) to avoid noise from React Query cancellations.
 */
const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Capture replays + traces at a conservative sample rate in prod.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
    replaysSessionSampleRate: 0,
    beforeSend(event, hint) {
      const err = hint.originalException;
      if (err && (err as { name?: string }).name === "AbortError") return null;
      return event;
    },
  });
}

export { Sentry };
